import Apps from 'api/apps';

import { Resource, computedMapById, syncDataToLocalStorage } from './store';

const LS_KEY = 'Apps.state';

export default Resource.build(({ state, values }) => {
  syncDataToLocalStorage('Apps.state', state);

  return {
    name: 'Apps',
    state,

    values: {
      // ...values,
      byId: computedMapById(state),
    },

    actReqs: {
      fetch: Apps.fetchList.bind(Apps),
      add: Apps.create.bind(Apps),
      update: Apps.update.bind(Apps),
      delete: Apps.delete.bind(Apps),
    },
  };
});
